import { Elm } from "@/components/elm/Newsletter.elm"
import { logDecodingError } from "@/helpers/airbrake"
import { pushGa4Event } from "@/helpers/ga4_helper"
import Recaptcha from "@/helpers/recaptcha"

declare global {
  interface Window {
    elmNewsletterFlags: Flags
  }
}

const initNewsletter = async (): Promise<void> => {
  const node = document.getElementById("elm-newsletter")
  const flags = window.elmNewsletterFlags
  const RECAPTCHA_KEY = node?.dataset.recaptchaKey
  const app = Elm.Newsletter.init({ node, flags })

  if (RECAPTCHA_KEY) {
    new Recaptcha("elm-newsletter-recaptcha", RECAPTCHA_KEY, app)
  }

  app.ports.flagDecodingError.subscribe(() => logDecodingError(flags))
  app.ports.pushGa4Event.subscribe(pushGa4Event)
}

void initNewsletter()
